var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pa-0 mt-n3", attrs: { cols: "12" } },
            [
              false
                ? _c(
                    "v-toolbar",
                    {
                      attrs: { width: "100%", color: "backlight", flat: "" },
                      scopedSlots: _vm._u(
                        [
                          false
                            ? {
                                key: "extension",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-tabs",
                                      {
                                        attrs: { xs: "" },
                                        model: {
                                          value: _vm.filter,
                                          callback: function ($$v) {
                                            _vm.filter = $$v
                                          },
                                          expression: "filter",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-tab",
                                          {
                                            attrs: {
                                              dense: "",
                                              xs: "",
                                              value: "all",
                                            },
                                          },
                                          [_vm._v("All")]
                                        ),
                                        _c(
                                          "v-tab",
                                          {
                                            attrs: {
                                              dense: "",
                                              sm: "",
                                              value: "fail",
                                            },
                                          },
                                          [_vm._v("Fail")]
                                        ),
                                        _c(
                                          "v-tab",
                                          {
                                            attrs: {
                                              dense: "",
                                              sm: "",
                                              value: "success",
                                            },
                                          },
                                          [_vm._v("Success")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("v-toolbar-title", [_vm._v("Activity")]),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _vm.showSearch
                            ? _c("v-text-field", {
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              })
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showSearch = !_vm.showSearch
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("search")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              class: _vm.selectedJob.length ? "d-none d-md-block" : 0,
              attrs: {
                cols: 12,
                md: _vm.selectedJob.length > 0 ? 6 : 12,
                lg: _vm.selectedJob.length > 0 ? 9 : 12,
              },
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-toolbar",
                        { staticClass: "d-inline-block", attrs: { flat: "" } },
                        [
                          _vm.lightning
                            ? _c("v-toolbar-title", [_vm._v("Lightning")])
                            : _vm._e(),
                          _vm.lightningCatalogs
                            ? _c("v-toolbar-title", [_vm._v("Lightning")])
                            : _vm._e(),
                          _vm.packagePublishes
                            ? _c("v-toolbar-title", [
                                _vm._v("Package Publishes"),
                              ])
                            : _vm._e(),
                          !_vm.lightning &&
                          !_vm.lightningCatalogs &&
                          !_vm.packagePublishes
                            ? _c("v-toolbar-title", [
                                _vm._v(" Model Pipeline "),
                              ])
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "float-left ml-3 elevation-0 primary--text",
                              attrs: {
                                fab: "",
                                text: "",
                                "x-small": "",
                                color: "default",
                                disabled: _vm.newJobCount === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getJobs()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "24", color: "primary" } },
                                [_vm._v("refresh")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            { class: _vm.newJobCount === 0 ? "disabled" : "" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s("Jobs (" + _vm.newJobCount + ")") +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      !_vm.isSingleMode
                        ? _c("v-text-field", {
                            attrs: {
                              "prepend-icon": "search",
                              label: "Search Jobs",
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      !_vm.isSingleMode
                        ? _c(
                            "v-menu",
                            {
                              ref: "showDateSearch",
                              attrs: {
                                "close-on-content-click": false,
                                "return-value": _vm.dateRange,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "290px",
                              },
                              on: {
                                "update:returnValue": function ($event) {
                                  _vm.dateRange = $event
                                },
                                "update:return-value": function ($event) {
                                  _vm.dateRange = $event
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-text-field",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  label: "Date Range",
                                                  "prepend-icon": "event",
                                                  readonly: "",
                                                  "append-icon": "clear",
                                                },
                                                on: {
                                                  "click:append": function (
                                                    $event
                                                  ) {
                                                    _vm.dateRange = []
                                                  },
                                                },
                                                model: {
                                                  value: _vm.dateRangeText,
                                                  callback: function ($$v) {
                                                    _vm.dateRangeText = $$v
                                                  },
                                                  expression: "dateRangeText",
                                                },
                                              },
                                              "v-text-field",
                                              attrs,
                                              false
                                            ),
                                            on
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3312621747
                              ),
                              model: {
                                value: _vm.showDateSearch,
                                callback: function ($$v) {
                                  _vm.showDateSearch = $$v
                                },
                                expression: "showDateSearch",
                              },
                            },
                            [
                              _c(
                                "v-date-picker",
                                {
                                  attrs: {
                                    "no-title": "",
                                    scrollable: "",
                                    range: true,
                                  },
                                  model: {
                                    value: _vm.dateRange,
                                    callback: function ($$v) {
                                      _vm.dateRange = $$v
                                    },
                                    expression: "dateRange",
                                  },
                                },
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "error" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showDateSearch = false
                                        },
                                      },
                                    },
                                    [_vm._v("Cancel")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.updateDateRange()
                                        },
                                      },
                                    },
                                    [_vm._v("OK")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "mt-4 float-right",
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewAll()
                                },
                              },
                            },
                            [_vm._v("View All Jobs")]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.tableHeaders,
                  items:
                    _vm.selectedEvent === null ? _vm.jobs : _vm.selectedJob,
                  "single-select": true,
                  options: _vm.tableOptions,
                  "footer-props": {
                    "items-per-page-options": [
                      15,
                      30,
                      50,
                      { text: "All", value: -1 },
                    ],
                  },
                  search: _vm.search,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "server-items-length": _vm.totalJobsCount,
                  loading: !_vm.jobsLoaded,
                  "hide-default-footer":
                    _vm.selectedEvent !== null || _vm.isSingleMode,
                  "calculate-widths": true,
                  "mobile-breakpoint": "0",
                  "no-data-text": "No jobs found",
                },
                on: {
                  "click:row": _vm.rowClick,
                  "update:options": function ($event) {
                    _vm.tableOptions = $event
                  },
                  "update:search": function ($event) {
                    _vm.search = $event
                  },
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `header.metadata`,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "text-bolder" }, [
                            _vm._v(" Customer "),
                          ]),
                          !_vm.isSingleMode
                            ? _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "nudge-width": 200,
                                    "offset-x": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    class:
                                                      _vm.filterCustomerActive
                                                        ? "filter-active"
                                                        : "filter-inactive",
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.filterCustomerActive
                                                        ? "filter_list"
                                                        : "filter_list_off"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2778989201
                                  ),
                                  model: {
                                    value: _vm.showFilterCustomerMenu,
                                    callback: function ($$v) {
                                      _vm.showFilterCustomerMenu = $$v
                                    },
                                    expression: "showFilterCustomerMenu",
                                  },
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "pa-2" },
                                        [
                                          _c(
                                            "v-list",
                                            { staticClass: "filter-list" },
                                            [
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c("v-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      chips: "",
                                                      label: "Company",
                                                      items:
                                                        _vm.filterCompanyNameOptions,
                                                      "item-text": "text",
                                                      "item-value": "value",
                                                      clearable: true,
                                                      multiple: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filterCompanyNames,
                                                      callback: function ($$v) {
                                                        _vm.filterCompanyNames =
                                                          $$v
                                                      },
                                                      expression:
                                                        "filterCompanyNames",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              !_vm.lightning
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c("v-autocomplete", {
                                                        attrs: {
                                                          dense: "",
                                                          chips: "",
                                                          label: "Project",
                                                          items:
                                                            _vm.filterProjectNameOptions,
                                                          "item-text": "text",
                                                          "item-value": "value",
                                                          clearable: true,
                                                          multiple: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.filterProjectNames,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.filterProjectNames =
                                                              $$v
                                                          },
                                                          expression:
                                                            "filterProjectNames",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c("v-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      chips: "",
                                                      label: "User",
                                                      items:
                                                        _vm.filterUserNameOptions,
                                                      "item-text": "text",
                                                      "item-value": "value",
                                                      clearable: true,
                                                      multiple: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filterUserNames,
                                                      callback: function ($$v) {
                                                        _vm.filterUserNames =
                                                          $$v
                                                      },
                                                      expression:
                                                        "filterUserNames",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-card-actions",
                                        { staticClass: "w-340 pr-5 pt-0 pb-3" },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "btn-green btn-round",
                                              attrs: {
                                                text: "",
                                                color: "white",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changedFilters()
                                                },
                                              },
                                            },
                                            [_vm._v(" ✓ ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.filterCompanyNames.length > 0
                            ? _c("br")
                            : _vm._e(),
                          _vm.filterCompanyNames.length > 0
                            ? _c("label", { staticClass: "mr-1" }, [
                                _vm._v(" Companies: "),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.filterCompanyNames, function (cn, i) {
                            return _c(
                              "v-chip",
                              {
                                key: cn,
                                staticClass: "filter-chip",
                                attrs: { close: "" },
                                on: {
                                  "click:close": function ($event) {
                                    _vm.filterCompanyNames.splice(i, 1)
                                    _vm.changedFilters()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(cn) + " ")]
                            )
                          }),
                          _vm.filterProjectNames.length > 0
                            ? _c("br")
                            : _vm._e(),
                          _vm.filterProjectNames.length > 0
                            ? _c("label", { staticClass: "mr-1" }, [
                                _vm._v(" Projects: "),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.filterProjectNames, function (pn, i) {
                            return _c(
                              "v-chip",
                              {
                                key: pn,
                                staticClass: "filter-chip",
                                attrs: { close: "" },
                                on: {
                                  "click:close": function ($event) {
                                    _vm.filterProjectNames.splice(i, 1)
                                    _vm.changedFilters()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(pn) + " ")]
                            )
                          }),
                          _vm.filterUserNames.length > 0 ? _c("br") : _vm._e(),
                          _vm.filterUserNames.length > 0
                            ? _c("label", { staticClass: "mr-1" }, [
                                _vm._v(" Users: "),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.filterUserNames, function (un, i) {
                            return _c(
                              "v-chip",
                              {
                                key: un,
                                staticClass: "filter-chip",
                                attrs: { close: "" },
                                on: {
                                  "click:close": function ($event) {
                                    _vm.filterUserNames.splice(i, 1)
                                    _vm.changedFilters()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(un) + " ")]
                            )
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: `header.pass`,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "text-bolder" }, [
                            _vm._v(" Pass "),
                          ]),
                          !_vm.isSingleMode
                            ? _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "nudge-width": 200,
                                    "offset-x": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    class:
                                                      _vm.filterActiveOnlyJobs ||
                                                      _vm.filterCancelledJobs ||
                                                      _vm.filterErrorJobs
                                                        ? "filter-active"
                                                        : "filter-inactive",
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.filterActiveOnlyJobs ||
                                                        _vm.filterCancelledJobs ||
                                                        _vm.filterErrorJobs
                                                        ? "filter_list"
                                                        : "filter_list_off"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1141634545
                                  ),
                                  model: {
                                    value: _vm.showFilterPassMenu,
                                    callback: function ($$v) {
                                      _vm.showFilterPassMenu = $$v
                                    },
                                    expression: "showFilterPassMenu",
                                  },
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "pa-2" },
                                        [
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass: "mt-0",
                                                    attrs: {
                                                      label:
                                                        "Active (including failed but not completed)",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changedActiveOnlyJobs()
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filterActiveOnlyJobs,
                                                      callback: function ($$v) {
                                                        _vm.filterActiveOnlyJobs =
                                                          $$v
                                                      },
                                                      expression:
                                                        "filterActiveOnlyJobs",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass: "mt-0",
                                                    attrs: {
                                                      label: "Cancelled",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changedCancelledJobs()
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filterCancelledJobs,
                                                      callback: function ($$v) {
                                                        _vm.filterCancelledJobs =
                                                          $$v
                                                      },
                                                      expression:
                                                        "filterCancelledJobs",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass: "mt-0",
                                                    attrs: { label: "Error" },
                                                    model: {
                                                      value:
                                                        _vm.filterErrorJobs,
                                                      callback: function ($$v) {
                                                        _vm.filterErrorJobs =
                                                          $$v
                                                      },
                                                      expression:
                                                        "filterErrorJobs",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-card-actions",
                                        { staticClass: "pr-5 pt-0 pb-3" },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "btn-green btn-round",
                                              attrs: {
                                                text: "",
                                                color: "white",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changedFilters()
                                                },
                                              },
                                            },
                                            [_vm._v(" ✓ ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.filterActiveOnlyJobs
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "filter-chip",
                                  attrs: { close: "" },
                                  on: {
                                    "click:close": function ($event) {
                                      return _vm.clearActiveOnlyJobFilter()
                                    },
                                  },
                                },
                                [_vm._v(" Active ")]
                              )
                            : _vm._e(),
                          _vm.filterCancelledJobs
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "filter-chip",
                                  attrs: { close: "" },
                                  on: {
                                    "click:close": function ($event) {
                                      return _vm.clearCancelledJobFilter()
                                    },
                                  },
                                },
                                [_vm._v(" Cancelled ")]
                              )
                            : _vm._e(),
                          _vm.filterErrorJobs
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "filter-chip",
                                  attrs: { close: "" },
                                  on: {
                                    "click:close": function ($event) {
                                      return _vm.clearErrorJobFilter()
                                    },
                                  },
                                },
                                [_vm._v(" Error ")]
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: `item.pass`,
                      fn: function ({ item }) {
                        return [
                          item.eventsLoaded
                            ? _c(
                                "div",
                                {
                                  staticClass: "border-left pass-circle",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleClaimedBy(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-avatar",
                                    {
                                      attrs: { color: _vm.getPassColor(item) },
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            class:
                                                              [1, 5].indexOf(
                                                                item.jobStatus
                                                              ) >= 0
                                                                ? "remove"
                                                                : "",
                                                            attrs: { dark: "" },
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.getPassIconName(
                                                                item
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("div", { attrs: { small: "" } }, [
                                            _vm._v(
                                              _vm._s(
                                                item.jobClaim.claimedByUserId
                                                  ? "Unclaim"
                                                  : "Claim"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  item.jobClaim.claimedByUserId
                                    ? _c(
                                        "v-avatar",
                                        {
                                          staticClass: "claimed-by-circle",
                                          attrs: { color: "black", size: "20" },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g(
                                                            _vm._b(
                                                              {},
                                                              "span",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.getAvatarInitials(
                                                                    item.jobClaim
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("div", [
                                                _c("div", [
                                                  _vm._v(
                                                    "Claimed By: " +
                                                      _vm._s(
                                                        item.jobClaim
                                                          .claimedByUserName
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    "Email: " +
                                                      _vm._s(
                                                        item.jobClaim
                                                          .claimedByUserEmail
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    "Date: " +
                                                      _vm._s(
                                                        _vm.displayDate(
                                                          item?.jobClaim
                                                            ?.claimedByDateTime
                                                        ) || "N/A"
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "border-left" },
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "mb-n1",
                                    attrs: { type: "avatar" },
                                  }),
                                ],
                                1
                              ),
                        ]
                      },
                    },
                    {
                      key: `item.id`,
                      fn: function ({ item }) {
                        return [
                          item.parsedMetadata
                            ? _c(
                                "div",
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    title: item.parsedMetadata.ModelName,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.parsedMetadata.ModelName) +
                                      " "
                                  ),
                                ]
                              )
                            : _c("v-skeleton-loader", {
                                staticClass: "mb-n1",
                                attrs: { type: "text" },
                              }),
                          _c(
                            "div",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "v-row",
                                [
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _vm._v("Job Id: " + _vm._s(item.id)),
                                  ]),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-right",
                                      attrs: { cols: "6" },
                                    },
                                    [
                                      item === _vm.selectedJob[0]
                                        ? _c(
                                            "v-menu",
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "ml-1 mr-4",
                                                                attrs: {
                                                                  height: "16",
                                                                  width: "16",
                                                                  icon: "",
                                                                  color:
                                                                    "primary",
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "more_horiz"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: { dense: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.shareJob()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "Share via email"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: { dense: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.copyJobLink(
                                                            item.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v("Copy link"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.lightning ||
                                                  !_vm.packagePublishes
                                                    ? _c(
                                                        "v-list-item",
                                                        {
                                                          attrs: { dense: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.showFileDialog = true
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "View Files"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.lightning ||
                                                  !_vm.packagePublishes
                                                    ? _c(
                                                        "v-list-item",
                                                        {
                                                          attrs: { dense: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.goToBlobStorage(
                                                                item,
                                                                _vm
                                                                  .StorageAccountType
                                                                  .ImportBundle
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "Import Blob Storage"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.lightning ||
                                                  !_vm.packagePublishes
                                                    ? _c(
                                                        "v-list-item",
                                                        {
                                                          attrs: { dense: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.goToBlobStorage(
                                                                item,
                                                                _vm
                                                                  .StorageAccountType
                                                                  .ModelData
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "Extract Blob Storage"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.lightning ||
                                                  !_vm.packagePublishes
                                                    ? _c(
                                                        "v-list-item",
                                                        {
                                                          attrs: { dense: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.goToBlobStorage(
                                                                item,
                                                                _vm
                                                                  .StorageAccountType
                                                                  .ModelSync
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "Transform Blob Storage"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c("v-spacer"),
                                                  _c("hr"),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: { dense: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.showCancelJobWarning = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "Suspend Publish"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  false
                                                    ? _c(
                                                        "v-list-item",
                                                        {
                                                          attrs: { dense: "" },
                                                          on: {
                                                            click:
                                                              _vm.resumePublishJob,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "Resume Publish"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: { dense: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.showRunDbMaintenanceWarning = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "Run DB Maintenance"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: { dense: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.replayModelBackup()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "Replay Model Backup"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c("textarea", {
                                        ref: _vm.getRef(item.id),
                                        staticClass: "copyText",
                                        domProps: {
                                          value:
                                            _vm.origin +
                                            _vm.routeName +
                                            "/" +
                                            item.id,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", [
                            _vm._v(_vm._s(_vm.displayDuration(item.jobTime))),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.metadata`,
                      fn: function ({ item }) {
                        return [
                          item.parsedMetadata
                            ? _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(item.parsedMetadata.CompanyName)
                                  ),
                                ]),
                              ])
                            : _c("v-skeleton-loader", {
                                staticClass: "mb-n1",
                                attrs: { type: "text" },
                              }),
                          item.parsedMetadata
                            ? _c("div", [
                                item.parsedMetadata.ProjectName
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(item.parsedMetadata.ProjectName)
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v("Project Name Not Available"),
                                    ]),
                              ])
                            : _c("v-skeleton-loader", {
                                staticClass: "mb-n1",
                                attrs: { type: "text" },
                              }),
                          item.parsedMetadata
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.parsedMetadata.UserDisplayName
                                    ) +
                                    " " +
                                    _vm._s(
                                      item.parsedMetadata.UserEmail
                                        ? "(" +
                                            item.parsedMetadata.UserEmail +
                                            ")"
                                        : "Email Not Available"
                                    ) +
                                    " "
                                ),
                              ])
                            : _c("v-skeleton-loader", {
                                staticClass: "mb-n1",
                                attrs: { type: "text" },
                              }),
                        ]
                      },
                    },
                    {
                      key: `item.process`,
                      fn: function ({ item }) {
                        return [
                          item.eventsLoaded
                            ? _c(
                                "div",
                                [
                                  item.jobStatus === 6
                                    ? _c("v-row", { attrs: { cols: "12" } }, [
                                        _c(
                                          "div",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c(
                                              "v-avatar",
                                              {
                                                attrs: {
                                                  size: "16",
                                                  color: "error",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      "x-small": "",
                                                      dark: "",
                                                    },
                                                  },
                                                  [_vm._v("update_disabled")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [_vm._v("E")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _c("v-row", { attrs: { cols: "12" } }, [
                                        _c(
                                          "div",
                                          { attrs: { cols: "12" } },
                                          [
                                            item.extractStatus === 2
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: _vm.getIconColor(
                                                        item,
                                                        _vm.PipelinePhaseType
                                                          .Extract
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("done")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.extractStatus === 1
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: _vm.getIconColor(
                                                        item,
                                                        _vm.PipelinePhaseType
                                                          .Extract
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "rotate",
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("update")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.extractStatus === 3
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: "error",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("warning")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            [0, 4].indexOf(
                                              item.extractStatus
                                            ) >= 0
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: "grey",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("remove")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [_vm._v("E")]
                                            ),
                                            item.newExtractEvent
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      title: "New Event",
                                                      "x-small": "",
                                                      color: "primary",
                                                    },
                                                  },
                                                  [_vm._v("flag")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                  item.jobStatus === 6
                                    ? _c("v-row", { attrs: { cols: "12" } }, [
                                        _c(
                                          "div",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c(
                                              "v-avatar",
                                              {
                                                attrs: {
                                                  size: "16",
                                                  color: "error",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      "x-small": "",
                                                      dark: "",
                                                    },
                                                  },
                                                  [_vm._v("update_disabled")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [_vm._v("T")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _c("v-row", { attrs: { cols: "12" } }, [
                                        _c(
                                          "div",
                                          { attrs: { cols: "12" } },
                                          [
                                            item.transformStatus === 2
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: _vm.getIconColor(
                                                        item,
                                                        _vm.PipelinePhaseType
                                                          .Transform
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("done")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.transformStatus === 1
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: _vm.getIconColor(
                                                        item,
                                                        _vm.PipelinePhaseType
                                                          .Transform
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "rotate",
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("update")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.transformStatus === 3
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: "error",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("warning")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            [0, 4].indexOf(
                                              item.transformStatus
                                            ) >= 0
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: "grey",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("remove")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [_vm._v("T")]
                                            ),
                                            item.newTransformEvent
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      title: "New Event",
                                                      "x-small": "",
                                                      color: "primary",
                                                    },
                                                  },
                                                  [_vm._v("flag")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                  item.jobStatus === 6
                                    ? _c("v-row", { attrs: { cols: "12" } }, [
                                        _c(
                                          "div",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c(
                                              "v-avatar",
                                              {
                                                attrs: {
                                                  size: "16",
                                                  color: "error",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      "x-small": "",
                                                      dark: "",
                                                    },
                                                  },
                                                  [_vm._v("update_disabled")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [_vm._v("L")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _c("v-row", { attrs: { cols: "12" } }, [
                                        _c(
                                          "div",
                                          { attrs: { cols: "12" } },
                                          [
                                            item.loadStatus === 2
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: _vm.getIconColor(
                                                        item,
                                                        _vm.PipelinePhaseType
                                                          .Load
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("done")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.loadStatus === 1
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    staticClass: "rotate",
                                                    attrs: {
                                                      size: "16",
                                                      color: _vm.getIconColor(
                                                        item,
                                                        _vm.PipelinePhaseType
                                                          .Load
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("update")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.loadStatus === 3
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: "error",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("warning")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            [0, 4].indexOf(item.loadStatus) >= 0
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      color: "grey",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          dark: "",
                                                        },
                                                      },
                                                      [_vm._v("remove")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [_vm._v("L")]
                                            ),
                                            item.newLoadEvent
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      title: "New Event",
                                                      "x-small": "",
                                                      color: "primary",
                                                    },
                                                  },
                                                  [_vm._v("flag")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("v-skeleton-loader", {
                                    attrs: { type: "text" },
                                  }),
                                  _c("v-skeleton-loader", {
                                    attrs: { type: "text" },
                                  }),
                                  _c("v-skeleton-loader", {
                                    attrs: { type: "text" },
                                  }),
                                ],
                                1
                              ),
                        ]
                      },
                    },
                    {
                      key: `item.duration`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "min-w-160" },
                            [
                              !item.extractStartDT
                                ? _c("v-skeleton-loader", {
                                    staticClass: "mt-1",
                                    attrs: { type: "text" },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.displayDuration(item.extractTime)
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "min-w-160" },
                            [
                              !item.transformStartDT
                                ? _c("v-skeleton-loader", {
                                    staticClass: "mt-1",
                                    attrs: { type: "text" },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.displayDuration(
                                            item.transformTime
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "min-w-160" },
                            [
                              !item.loadStartDT
                                ? _c("v-skeleton-loader", {
                                    staticClass: "mt-1",
                                    attrs: { type: "text" },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.displayDuration(item.loadTime)
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.start`,
                      fn: function ({ item }) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.displayDate(item?.extractStartDT) || "N/A"
                              )
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.displayDate(item?.transformStartDT) || "N/A"
                              )
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.displayDate(item?.loadStartDT) || "N/A"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.platform`,
                      fn: function ({ item }) {
                        return [
                          item.parsedMetadata
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.parsedMetadata.DesktopPlatform
                                    ) +
                                    " " +
                                    _vm._s(
                                      item.parsedMetadata.AddInVersion
                                        ? item.parsedMetadata.AddInVersion
                                        : ""
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          item.parsedMetadata
                            ? _c(
                                "div",
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.getJobSize(item)) + " MB "
                                  ),
                                  !_vm.lightning || !_vm.packagePublishes
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { right: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        {
                                                          attrs: { size: "16" },
                                                          on: {
                                                            mouseover:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.clearMetadataFlag(
                                                                  item.id
                                                                )
                                                              },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [_vm._v("info")]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " Parts: " +
                                                _vm._s(
                                                  item.parsedMetadata.NumParts
                                                )
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              " FabParts: " +
                                                _vm._s(
                                                  item.parsedMetadata
                                                    .NumFabParts
                                                )
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              " Assemblies: " +
                                                _vm._s(
                                                  item.parsedMetadata
                                                    .NumAssemblies
                                                )
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              " Attachments: " +
                                                _vm._s(
                                                  item.parsedMetadata
                                                    .NumAttachments
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.newMetadata.indexOf(item.id) > -1
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-1",
                                          attrs: {
                                            title: "New Metadata",
                                            "x-small": "",
                                            color: "primary",
                                          },
                                        },
                                        [_vm._v("flag")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.parsedMetadata
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(item.parsedMetadata.WorkflowName) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedJob,
                  callback: function ($$v) {
                    _vm.selectedJob = $$v
                  },
                  expression: "selectedJob",
                },
              }),
              _vm.selectedEvent !== null
                ? _c("model-publish-telemetry", {
                    attrs: { "selected-event": _vm.selectedEvent },
                    on: { "clear-selected-event": _vm.clearSelectedEvent },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.selectedJob.length > 0
            ? _c(
                "v-col",
                { attrs: { cols: "12", md: "6", lg: "3" } },
                [
                  _c("model-publish-sidebar", {
                    ref: "sidebar",
                    attrs: {
                      "selected-job": _vm.selectedJob,
                      "selected-event": _vm.selectedEvent,
                      "replay-job-ids": _vm.replayJobIds,
                    },
                    on: {
                      "select-event": _vm.selectEvent,
                      "events-loaded": _vm.changeEventsLoaded,
                      "update-replay-requests": _vm.updateReplayRequests,
                      "clear-selected-job": _vm.clearSelectedJob,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.showEmailDialog
        ? _c(
            "v-dialog",
            {
              attrs: { width: "800px" },
              model: {
                value: _vm.showEmailDialog,
                callback: function ($$v) {
                  _vm.showEmailDialog = $$v
                },
                expression: "showEmailDialog",
              },
            },
            [
              _c("model-publish-email", {
                attrs: {
                  selectedJob: _vm.selectedJob,
                  origin: _vm.origin,
                  routeName: _vm.routeName,
                },
                on: {
                  "close-email-dialog": function ($event) {
                    _vm.showEmailDialog = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showFileDialog && !_vm.lightning && !_vm.packagePublishes
        ? _c(
            "v-dialog",
            {
              attrs: { width: "400px" },
              model: {
                value: _vm.showFileDialog,
                callback: function ($$v) {
                  _vm.showFileDialog = $$v
                },
                expression: "showFileDialog",
              },
            },
            [
              _c("model-publish-files", {
                attrs: { selectedJob: _vm.selectedJob },
                on: {
                  "close-file-dialog": function ($event) {
                    _vm.showFileDialog = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showCancelJobWarning
        ? _c(
            "v-dialog",
            {
              attrs: {
                width: "500px",
                "overlay-color": "transparent",
                "content-class": "bordered",
              },
              model: {
                value: _vm.showCancelJobWarning,
                callback: function ($$v) {
                  _vm.showCancelJobWarning = $$v
                },
                expression: "showCancelJobWarning",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      "Cancel Publish Job " +
                        _vm._s(_vm.selectedJob[0].parsedMetadata.ModelName)
                    ),
                  ]),
                  _c("v-card-text", [
                    _vm._v(
                      " Canceling publish will result in the loss of all publish progress. This action can not be undone. "
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "text-right" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.showCancelJobWarning = false
                            },
                          },
                        },
                        [_vm._v("Back")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.cancelPublishJob()
                            },
                          },
                        },
                        [_vm._v("Cancel Publish")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showRunDbMaintenanceWarning
        ? _c(
            "v-dialog",
            {
              attrs: {
                width: "500px",
                "overlay-color": "transparent",
                "content-class": "bordered",
              },
              model: {
                value: _vm.showRunDbMaintenanceWarning,
                callback: function ($$v) {
                  _vm.showRunDbMaintenanceWarning = $$v
                },
                expression: "showRunDbMaintenanceWarning",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v(" Run Db Maintenance ")]),
                  _c("v-card-text", [
                    _vm._v(" Are you sure you want to run db maintenance ? "),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "text-right" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.runDbMaintenance()
                            },
                          },
                        },
                        [_vm._v(" YES ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error" },
                          on: {
                            click: function ($event) {
                              _vm.showRunDbMaintenanceWarning = false
                            },
                          },
                        },
                        [_vm._v(" NO ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showReplayModelBackupWarning
        ? _c(
            "v-dialog",
            {
              attrs: {
                width: "500px",
                "overlay-color": "transparent",
                "content-class": "bordered",
              },
              model: {
                value: _vm.showReplayModelBackupWarning,
                callback: function ($$v) {
                  _vm.showReplayModelBackupWarning = $$v
                },
                expression: "showReplayModelBackupWarning",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v(" Replay Model Backup ")]),
                  _c("v-card-text", [
                    _vm._v(
                      " Are you sure you want to replay the model backup for Job " +
                        _vm._s(_vm.selectedJob[0].id) +
                        "? "
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "text-right" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmReplayModelBackup()
                            },
                          },
                        },
                        [_vm._v(" YES ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error" },
                          on: {
                            click: function ($event) {
                              _vm.showReplayModelBackupWarning = false
                            },
                          },
                        },
                        [_vm._v(" NO ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showMessageBoxDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                width: "500px",
                "overlay-color": "transparent",
                "content-class": "bordered",
              },
              model: {
                value: _vm.showMessageBoxDialog,
                callback: function ($$v) {
                  _vm.showMessageBoxDialog = $$v
                },
                expression: "showMessageBoxDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { class: _vm.messageBoxColor + "--text" },
                    [_vm._v(" " + _vm._s(_vm.messageBoxTitle) + " ")]
                  ),
                  _c("v-card-text", [
                    _vm._v(" " + _vm._s(_vm.messageBoxText) + " "),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "text-right" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: _vm.messageBoxColor },
                          on: {
                            click: function ($event) {
                              _vm.showMessageBoxDialog = false
                            },
                          },
                        },
                        [_vm._v(" OK ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }